import React from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import TXT from "presentational/common/multinational/TXT";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

// Desktop
const BOTTOM_PADDING_OF_FIRST_SECTION_FOR_DESKTOP = 64;
const BOTTOM_PADDING_BETWEEN_SECTIONS_FOR_DESKTOP = 40;
const BOTTOM_PADDING_OF_LAST_SECTION_FOR_DESKTOP = 72;

const FONT_SIZE_OF_FIRST_SECTION_HEADLINE_FOR_DESKTOP = 40;
const FONT_SIZE_OF_MIDDLE_SECTION_HEADLINE_FOR_DESKTOP = 24;
const FONT_SIZE_OF_MIDDLE_SECTION_SUBCOPY_FOR_DESKTOP = 16;
const FONT_SIZE_OF_LAST_SECTION_HEADLINE_FOR_DESKTOP = 36;
const FONT_SIZE_OF_LAST_SECTION_SUBCOPY_FOR_DESKTOP = 16;

// Mobile
const BOTTOM_PADDING_OF_FIRST_SECTION_FOR_MOBILE = 48;
const BOTTOM_PADDING_BETWEEN_SECTIONS_FOR_MOBILE = 28;
const BOTTOM_PADDING_OF_LAST_SECTION_FOR_MOBILE = 56;

const FONT_SIZE_OF_FIRST_SECTION_HEADLINE_FOR_MOBILE = 30;
const FONT_SIZE_OF_MIDDLE_SECTION_HEADLINE_FOR_MOBILE = 20;
const FONT_SIZE_OF_MIDDLE_SECTION_SUBCOPY_FOR_MOBILE = 14;
const FONT_SIZE_OF_LAST_SECTION_HEADLINE_FOR_MOBILE = 28;
const FONT_SIZE_OF_LAST_SECTION_SUBCOPY_FOR_MOBILE = 14;

const ABOUT_SECTIONS = [
  {
    headline: <TXT name="msg_aboutPageHeader1" />,
    subcopy: <TXT name="msg_aboutPageSub1" />
  },
  {
    headline: <TXT name="msg_aboutPageHeader2" />,
    subcopy: <TXT name="msg_aboutPageSub2" />
  },
  {
    headline: <TXT name="msg_aboutPageHeader3" />,
    subcopy: <TXT name="msg_aboutPageSub3" />
  },
  {
    headline: <TXT name="msg_aboutPageHeader4" />,
    subcopy: <TXT name="msg_aboutPageSub4" />
  }
];

const fontCss = config.css.fontThickness;

const cssBase = {
  page: {
    backgroundColor: "#FFFFFF",
    color: "#111111"
  }
};

const cssDesktop = {
  page: cssBase.page,
  container: {
    margin: "0 auto",
    marginTop: -100,
    paddingBottom: 300
  },
  firstSection: {
    paddingBottom: BOTTOM_PADDING_OF_FIRST_SECTION_FOR_DESKTOP
  },
  middleSection: {
    paddingBottom:
      BOTTOM_PADDING_OF_LAST_SECTION_FOR_DESKTOP -
      BOTTOM_PADDING_BETWEEN_SECTIONS_FOR_DESKTOP
  },
  item: {
    paddingBottom: BOTTOM_PADDING_BETWEEN_SECTIONS_FOR_DESKTOP
  }
};

const cssMobile = {
  page: cssBase.page,
  container: {
    margin: "0 auto",
    marginTop: -100,
    paddingBottom: 200
  },
  firstSection: {
    paddingBottom: BOTTOM_PADDING_OF_FIRST_SECTION_FOR_MOBILE
  },
  middleSection: {
    paddingBottom:
      BOTTOM_PADDING_OF_LAST_SECTION_FOR_MOBILE -
      BOTTOM_PADDING_BETWEEN_SECTIONS_FOR_MOBILE
  },
  item: {
    paddingBottom: BOTTOM_PADDING_BETWEEN_SECTIONS_FOR_MOBILE
  }
};

const FirstHeadlineTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "desktop"
        ? FONT_SIZE_OF_FIRST_SECTION_HEADLINE_FOR_DESKTOP
        : FONT_SIZE_OF_FIRST_SECTION_HEADLINE_FOR_MOBILE,
    fontWeight: fontCss.bold,
    lineHeight: 1.35,
    color: "#111"
  }
})(Typography);

const AboutHeadlineTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "desktop"
        ? FONT_SIZE_OF_MIDDLE_SECTION_HEADLINE_FOR_DESKTOP
        : FONT_SIZE_OF_MIDDLE_SECTION_HEADLINE_FOR_MOBILE,
    fontWeight: fontCss.bold,
    paddingBottom: 6,
    lineHeight: 1.35,
    color: "#111"
  }
})(Typography);

const AboutSubcopyTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "desktop"
        ? FONT_SIZE_OF_MIDDLE_SECTION_SUBCOPY_FOR_DESKTOP
        : FONT_SIZE_OF_MIDDLE_SECTION_SUBCOPY_FOR_MOBILE,
    color: "rgba(17,17,17,0.86)"
  }
})(Typography);

const LastHeadlineTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "desktop"
        ? FONT_SIZE_OF_LAST_SECTION_HEADLINE_FOR_DESKTOP
        : FONT_SIZE_OF_LAST_SECTION_HEADLINE_FOR_MOBILE,
    fontWeight: fontCss.bold,
    paddingBottom: 6,
    lineHeight: 1.35,
    color: "#111"
  }
})(Typography);

const LastSubcopyTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "desktop"
        ? FONT_SIZE_OF_LAST_SECTION_SUBCOPY_FOR_DESKTOP
        : FONT_SIZE_OF_LAST_SECTION_SUBCOPY_FOR_MOBILE,
    color: "rgba(17,17,17,0.86)"
  }
})(Typography);

function RootAbout() {
  const deviceType = getDeviceType();
  const isDesktop = deviceType === "desktop";
  const css = isDesktop ? cssDesktop : cssMobile;

  return (
    <div style={css.page}>
      <div style={css.container}>
        <div style={css.firstSection}>
          <FirstHeadlineTypography>
            <TXT name="msg_aboutPageFirstHeader" />
          </FirstHeadlineTypography>
        </div>
        <div style={css.middleSection}>
          {ABOUT_SECTIONS.map((section, index) => (
            <div key={index} style={css.item}>
              <AboutHeadlineTypography>
                {section.headline}
              </AboutHeadlineTypography>
              <AboutSubcopyTypography>{section.subcopy}</AboutSubcopyTypography>
            </div>
          ))}
        </div>
        <div>
          <LastHeadlineTypography>
            <TXT name="msg_aboutPageLastHeader" />
          </LastHeadlineTypography>
          <LastSubcopyTypography>
            <TXT name="msg_aboutPageLastSub" />
          </LastSubcopyTypography>
        </div>
      </div>
    </div>
  );
}

export default RootAbout;
